import { render, staticRenderFns } from "./DeliveryListCanceledPage.vue?vue&type=template&id=3538f0b5&scoped=true&"
import script from "./DeliveryListCanceledPage.vue?vue&type=script&lang=js&"
export * from "./DeliveryListCanceledPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3538f0b5",
  null
  
)

export default component.exports